import React from "react";

const Skills = () => {
  const data = [
    {
      id: 1,
      title: "Programming Languages",
      details: "TypeScript, Java, Python",
    },
    {
      id: 2,
      title: "Technologies",
      details:
        "Node.js, Jest, Cypress, Docker, Kubernetes, REST, GraphQL, Amazon Web Services - S3, EC2, DynamoDB, SQL, Postgres, MySQL, Jira, Confluence, GitLab - CI/CD, GitHub",
    },
    {
      id: 3,
      title: "Management",
      details:
        "Leadership, Project Management, Team Building, Collaboration, Decision Making",
    },
  ];
  return (
    <div
      name="skills"
      className="w-full h-screen md:h-fit sm:h-fit bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center pt-20">
        <div className="pb-10 pt-5">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Skills
          </p>
        </div>
        {data.map((item, id) => (
          <div key={id} class="grid grid-cols-1 md:grid-cols-2 mb-4 pt-4">
            <div class="text-white font-bold text-xl">
              <h5>{item.title}</h5>
            </div>

            <div class="text-white font-normal text-lg">
              <h5>{item.details}</h5>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
